import PropTypes from 'prop-types';
import React from 'react';

import Avatar from './header/Avatar';
import useEntity from './hooks/useEntity';

const MemberAvatar = ({ id, ...props }) => {
  const member = useEntity({ id, type: 'members' });
  return <Avatar avatarUrl={member['avatar-url']} name={member['display-name']} {...props} />;
};

MemberAvatar.defaultProps = {};

MemberAvatar.propTypes = {
  id: PropTypes.string.isRequired,
};

export default MemberAvatar;
